import { Button, Modal, Text } from '$components'
import { ElementIntent } from '$components'

type ConfirmationModalProps = {
  onClose: () => void
  onConfirm: () => void
  isLoading: boolean
  title: string
  description?: string,
  intent: ElementIntent
}

export function ConfirmationModal({
  onClose,
  onConfirm,
  title,
  description,
  isLoading,
  intent = ElementIntent.Info,
}: ConfirmationModalProps) {

  return (
    <Modal
      onClose={onClose}
      className="w-[600px]"
    >
      <Modal.Header>
        <Modal.Heading>
          { title }
        </Modal.Heading>
      </Modal.Header>

      <Modal.Content>
        { description && (
          <Text>
            {description}
          </Text>
        )}

        <div className="flex gap-2 justify-end mt-6">
          <Button
            variant="secondary"
            size="lg"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            size="lg"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
            intent={intent}
          >
            Confirm
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  )
}
